import React from "react";
import {PageContainer} from "@renta-apps/athenaeum-react-components";
import AuthorizedPage from "../../models/base/AuthorizedPage";
import {InvoiceType} from "@/models/Enums";
import InvoicePageParameters from "@/models/InvoicePageParameters";
import {Utility} from "@renta-apps/athenaeum-toolkit";

import styles from "./InvoiceDetailsPage.module.scss";
import rentaToolsStyles from "@/pages/RentaTools.module.scss";
import InvoiceDetails from "@/components/InvoiceDetails/InvoiceDetails";

export default class InvoiceDetailsPage extends AuthorizedPage {

    private get invoiceType(): InvoiceType {
        let params: InvoicePageParameters | null = this.parameters as InvoicePageParameters;

        return params.invoiceType;
    }

    private get invoiceId(): string | null {
        let params: InvoicePageParameters | null = this.parameters as InvoicePageParameters;

        return params.invoiceId;
    }

    public render(): React.ReactNode {

        return (
            <PageContainer alertClassName={rentaToolsStyles.alert} className={Utility.css(rentaToolsStyles.pageContainer, styles.returnInspectionInvoiceDetails)}>

                <InvoiceDetails invoiceType={this.invoiceType}
                                invoiceId={this.invoiceId}
                />

            </PageContainer>
        );
    }
}